<template>
  <List :mapState="'restaurantProductsSubCategories'" :allDispatch="'restaurantProductsSubCategoriesAll'"></List>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
  name: 'Lists',
  components: {
    List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/restaurant/products/subcategories/list.vue